import * as yup from 'yup'

export class VehicleCheckInRearHeadOnPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInRearHeadOnPhotoFile?: File = undefined
}

export const vehicleCheckInRearHeadOnPhotoValidationSchema = yup.object({
  vehicleCheckInRearHeadOnPhotoFile: yup.mixed().notRequired()
})
